import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { DirectivesModule } from 'src/app/directives/directives.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { LimitationPopoverModule } from '../../charging-limitations/limitation-popover/limitation-popover.module';
import { JsonViewerModule } from '../../json-viewer/json-viewer.module';
import { DatatableFooterComponent } from '../../helper-components/datatable-footer/datatable-footer.component';
import { ActionHistoryTableComponent } from './action-history-table.component';

@NgModule({
  imports: [
    CommonModule,
    NgxDatatableModule,
    NgbModule,
    DirectivesModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    JsonViewerModule,
    LimitationPopoverModule,
    DatatableFooterComponent,
    RouterModule,
    MatTooltipModule,
    PipesModule
  ],
  declarations: [ActionHistoryTableComponent],
  exports: [ActionHistoryTableComponent]
})
export class ActionHistoryTableModule {}
